import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import AuthService from "../services/auth";
import qs from "query-string";
import ReactGA from "react-ga";
import "../styling/login.css";
import Mode from "../components/Mode";

interface ResetProps {}

export const Reset: React.FC<ResetProps> = ({}) => {
  ReactGA.pageview(window.location.pathname);
  const history = useHistory();

  const [password, setPassword] = useState("");
  const location = useLocation();
  //const params = useParams();
  //console.log(params)
  const parsed = qs.parse(location.search);
  //console.log(parsed);
  const [email, setEmail] = useState(parsed.email || "");
  const [hash, setHash] = useState(parsed.reset || "");

  function validateForm() {
    return email.length > 0 && password.length > 0;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      AuthService.resetPassword(email, hash, password).then(() => {
        AuthService.login(email, password, 0)
          .then(() => {
            history.push("/");
            alert("Your Passowrd is reset.")
          })
          .catch(() => {});
      });
    } catch (e: any) {
      alert(e.message);
    }
  };
  /*
  const handleSubmit = async (e) => {
    e.preventDefault();
    try{
      const temp = await axios.post('http://localhost:8080' + '/login', {
        email: email,//'garykk1234@gmail.com',
        password: password,//'password123',
      });
      setToken(temp.data.token);
      console.log(temp);
      console.log('Login succeeded');
      history.push({pathname:"/stream", state:{email: email, password:password}});
    } catch(e){
      alert(e.message);
    }
  };
*/
  return (
    <>
    <Row className="justify-content-center">
      <Col lg={6}>
        <div className="Login">
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control autoFocus type="email" value={email} disabled />
            </Form.Group>
            <Form.Group controlId="password">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 20,
              }}
            >
              <Button
                className="reset-button"
                block
                size="lg"
                type="submit"
                disabled={!validateForm()}
              >
                Reset Password
              </Button>
            </div>
            <p className="m-0">
              Don't have an account?
              <a href="/auth/register">Register here</a>
            </p>
            <p>
              Know Password? <a href="/auth/forgotPassword">Click Here</a>
            </p>
          </Form>
        </div>
      </Col>
    </Row>
    <Mode/>
    </>
  );
};
